module.exports = __webpack_public_path__ + "img/Web-Manuals_1.26d98b8d.jpg";